"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var green = {
  1: '#F2FAF5',
  2: '#99F2B4',
  3: '#21C712',
  4: '#12C748',
  5: '#26A34B'
};
var _default = green;
exports.default = _default;